import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import pocketalkLogo from '@/assets/logo.svg';
import sentioLogo from '@/assets/sentio_logo.svg';
import { PAGE_ROUTE_PATH } from '@/constants';
import { useGuestDisplay } from '@/hooks/useGuestDisplay';
import { useLoginUserInfo } from '@/hooks/useLoginUserInfo';

/**
 * ヘッダーロゴ管理 カスタムフック
 */
export const useLogo = () => {
  const { pathname } = useLocation();
  const { isSerialPlan } = useLoginUserInfo();
  const { isHostSerial } = useGuestDisplay();

  /**
   * ポケトークロゴを表示するか否か
   *
   * 以下のいずれかに該当する場合に true を返す
   * - シリアルプランの場合
   * - ホストがLIVEサービスの場合
   * - ゲスト画面の場合
   */
  const showPocketalkLogo = useMemo(
    () =>
      isSerialPlan || isHostSerial || pathname.startsWith(PAGE_ROUTE_PATH.GUEST),
    [isSerialPlan, isHostSerial, pathname],
  );

  /**
   * 表示するロゴ画像
   */
  const logoSrc = useMemo(
    () => (showPocketalkLogo ? pocketalkLogo : sentioLogo),
    [showPocketalkLogo],
  );

  /**
   * ロゴ画像に適用するCSSクラス名のキー
   * Header.module.scss のクラス名選択に使用する
   */
  const logoVariant: 'pocketalk' | 'sentio' = useMemo(
    () => (showPocketalkLogo ? 'pocketalk' : 'sentio'),
    [showPocketalkLogo],
  );

  return {
    logoSrc,
    logoVariant,
    showPocketalkLogo,
  };
};
